var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import t from 'prop-types';
import Draggable from 'react-draggable';

var MarcoAmpliacion = function (_Component) {
  _inherits(MarcoAmpliacion, _Component);

  function MarcoAmpliacion() {
    var _temp, _this, _ret;

    _classCallCheck(this, MarcoAmpliacion);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleDrag = function (e, data) {
      _this.props.onDragged(_this.props.id, data);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  MarcoAmpliacion.prototype.componentDidMount = function componentDidMount() {
    this.props.onMounted && this.props.onMounted(this.props.id);
  };

  MarcoAmpliacion.prototype.componentWillUnmount = function componentWillUnmount() {
    this.props.onUnmounted && this.props.onUnmounted(this.props.id);
  };

  MarcoAmpliacion.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (prevProps.factor !== this.props.factor) {
      var _props = this.props,
          id = _props.id,
          factor = _props.factor;
      this.props.onFactor && this.props.onFactor(id, prevProps.factor, factor);
    }
  };

  MarcoAmpliacion.prototype.render = function render() {
    var _this2 = this;

    var _props2 = this.props,
        id = _props2.id,
        factor = _props2.factor,
        reset = _props2.reset,
        deshabilitado = _props2.deshabilitado;
    var estiloFactorAmplicacion = {
      width: factor + '%',
      height: factor + '%'
    };
    var position = reset ? {
      position: {
        x: 0,
        y: 0
      }
    } : {};
    return React.createElement('div', {
      id: id,
      className: 'marcoAmpliacion'
    }, !deshabilitado && React.createElement(Draggable, _extends({}, position, {
      onDrag: this.handleDrag
    }), React.createElement('div', {
      className: 'factorAmpliacion',
      style: estiloFactorAmplicacion,
      ref: function ref(elem) {
        return _this2.elem = elem;
      }
    }, this.props.children)), deshabilitado && React.createElement('div', {
      className: 'factorAmpliacion',
      style: estiloFactorAmplicacion,
      ref: function ref(elem) {
        return _this2.elem = elem;
      }
    }, this.props.children));
  };

  return MarcoAmpliacion;
}(Component);

MarcoAmpliacion.propTypes = process.env.NODE_ENV !== "production" ? {
  id: t.string.isRequired,
  factor: t.number.isRequired,
  reset: t.bool,
  deshabilitado: t.bool,

  /** (id) => {...} */
  onMounted: t.func,

  /** (id) => {...} */
  onUnmounted: t.func,

  /** (id, data) => {...} */
  onDragged: t.func,

  /** (id, prevFactor, factor) => {...} */
  onFactor: t.func,
  children: t.any
} : {};
export default MarcoAmpliacion;